<template>
  <div class="mt-2">
    <v-card
      flat
      v-if="transaction"
      :color="$vuetify.theme.dark ? '#121212' : 'transparent'"
    >
      <div class="obrigado-por-comprar">
        <h2 class="text-h4 primary--text">
          Pedido #{{ transaction.order_id }}
        </h2>
        <v-btn
          outlined
          rounded
          depressed
          class="mb-1"
          color="primary"
          :to="{ name: 'courses' }"
        >
          Meus Cursos
        </v-btn>
      </div>

      <v-list
        class="display-list"
        :color="$vuetify.theme.dark ? '#121212' : 'transparent'"
      >
        <div>
          <v-list-item v-if="order.items.data[0].saleable.course">
            <v-list-item-icon>
              <v-icon>menu_book</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{
                order.items.data[0].saleable.course
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="transaction.net_amount">
            <v-list-item-icon>
              <v-icon>attach_money</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                R$ {{ formatPrice(transaction.gross_amount) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="transaction.payment_method_id">
            <v-list-item-icon>
              <v-img
                v-if="transaction.payment_method_id === 2"
                color="primary"
                src="/img/checkout/barcode-product.svg"
                width="16"
                class="mt-3 mb-3 mr-3"
              >
              </v-img>
              <v-img
                v-else-if="transaction.payment_method_id === 11"
                color="primary"
                src="/img/checkout/pix-tk.png"
                width="16"
                class="mt-3 mb-3 mr-3"
              >
              </v-img>
              <v-icon v-else>credit_card</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ paymentMethod }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="transaction.gateway_identifier">
            <v-list-item-icon>
              <v-icon>card_travel</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                transaction.gateway_identifier
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-btn
            rounded
            class="ma-3"
            depressed
            v-if="transaction.payment_method_id === 2"
            color="primary"
            :href="transaction.payment_link"
            target="_blank"
          >
            Visualizar Boleto
          </v-btn>
        </div>

        <div style="display: flex; align-items: flex-end; width: 100%">
          <v-flex
            v-if="transaction.payment_method_id === 11"
            class="qr-code-style"
          >
            <vue-qrcode
              :value="transaction.payment_link"
              :options="{
                width: 250,
              }"
              ref="pix_qr_code"
            ></vue-qrcode>
            <v-btn
              v-if="transaction.payment_method_id === 11"
              rounded
              depressed
              color="primary"
              class="ma-2"
              @click="copyToClipboard"
            >
              Copiar código de pagamento
            </v-btn>
            <p class="orange--text">Código válido por <b>30 minutos</b>.</p>
          </v-flex>
        </div>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  components: {
    VueQrcode,
  },
  props: {
    transaction: {
      required: true,
    },
    order: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    paymentMethod: function () {
      console.log(this.transaction.payment_method_id);
      switch (this.transaction.payment_method_id) {
        case 4:
          return "Cartão de Crédito";
        case 2:
          return "Boleto";
        case 11:
          return "PIX";
        default:
          return "Cartão";
      }
    },
  },
  methods: {
    formatPrice(price) {
      if (typeof price === "string") {
        price = parseFloat(price.replace(",", "."));
      }

      if (price === undefined) {
        return "0,00";
      }

      return price
        .toFixed(2) // Ensure two decimal places
        .replace(".", ",") // Replace decimal separator
        .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Add thousands separator
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.transaction.payment_link).then(
        function () {
          window.getApp.sendSnackMessage(
            `Código copiado com sucesso`,
            "success",
          );
        },
        function (err) {
          window.getApp.sendSnackMessage(
            `Ocorreu um problema ao tentar copiar`,
            "error",
          );
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.obrigado-por-comprar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-left: 16px;
  @media (max-width: 800px) {
    flex-wrap: wrap;
    align-items: flex-start;
  }
}
.display-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  @media (max-width: 800px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    align-items: flex-start;
  }
}
.qr-code-style {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min-content;
  p {
    font-size: 18px !important;
  }
}
</style>
